/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalysisResultCategory
 */
export interface AnalysisResultCategory {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the AnalysisResultCategory interface.
 */
export function instanceOfAnalysisResultCategory(value: object): value is AnalysisResultCategory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AnalysisResultCategoryFromJSON(json: any): AnalysisResultCategory {
    return AnalysisResultCategoryFromJSONTyped(json, false);
}

export function AnalysisResultCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AnalysisResultCategoryToJSON(json: any): AnalysisResultCategory {
    return AnalysisResultCategoryToJSONTyped(json, false);
}

export function AnalysisResultCategoryToJSONTyped(value?: AnalysisResultCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

